import { useContext } from 'react';
import IconMenu from '../../../IconMenu/IconMenu';
import { TableContext } from '../../Table.context';
import { Wrapper } from './TableActions.style';

export type TableActionsProps = {
  show: boolean;
  itemId: string;
};

export function TableActions(props: TableActionsProps) {
  const { itemId, show } = props;
  const { config, callbacks } = useContext(TableContext);
  const { rowActions } = config;

  function renderInner() {
    if (!show) return null;
    return <IconMenu actions={rowActions} itemId={itemId} onAction={callbacks.onAction} />;
  }

  return (
    <Wrapper className='TableActions-wrapper' data-testid='TableActions-wrapper'>
      {renderInner()}
    </Wrapper>
  );
}

export default TableActions;
